// Block I (UI-16): one person's tasks at a glance, opened from Team overview. Presentational: the
// numbers are worked out in TeamDashboard.js (the same breakdown it always showed) and handed in.
import React from 'react';
import { Button, Modal, ProgressBar, StatTile, StatusPill } from '../../ui';
import { PersonAvatar } from './TaskViews';
import { roleLabel } from './teamPeople';

const LOAD_TONE = { Heavy: 'warning', Normal: 'pending', Light: 'success' };

// detail: { user, pct, week: { completed, outstanding, overdue, total }, month: {…}, outstanding,
// teamAverage, load: 'Heavy' | 'Normal' | 'Light' }
export function MemberDetail({ detail, onClose, onViewTasks }) {
  if (!detail) return null;
  const { user } = detail;
  const tiles = (b) => (
    <div className="td-breakdown">
      <StatTile label="Completed" value={b.completed} />
      <StatTile label="Outstanding" value={b.outstanding} />
      <StatTile label="Overdue" value={b.overdue} />
      <StatTile label="Total" value={b.total} />
    </div>
  );
  return (
    <Modal open onClose={onClose} title={user.name} color="pastel-lilac" width={520}
      footer={<>
        <Button variant="tertiary" onClick={onClose}>Close</Button>
        <Button variant="secondary" onClick={() => onViewTasks(user.id)}>View their tasks</Button>
      </>}>
      <div className="td-drawer">
        <div className="td-member-head">
          <PersonAvatar user={user} size={44} />
          <span className="td-person__text">
            <span className="td-person__name">{user.name}</span>
            <span className="td-person__sub">{roleLabel(user.teamRole || user.role)}</span>
          </span>
        </div>
        <ProgressBar label="Overall completion" value={detail.pct} max={100} />
        <div className="td-drawer__row"><span className="td-drawer__label">This week</span>{tiles(detail.week)}</div>
        <div className="td-drawer__row"><span className="td-drawer__label">This month</span>{tiles(detail.month)}</div>
        <div className="td-drawer__row">
          <span className="td-drawer__label">Workload</span>
          <div className="td-row-wrap">
            <StatusPill tone={LOAD_TONE[detail.load]}>{detail.load}</StatusPill>
            <span className="td-muted">
              {detail.outstanding} outstanding {detail.outstanding === 1 ? 'task' : 'tasks'}; the team average is {Math.round(detail.teamAverage)}.
            </span>
          </div>
        </div>
      </div>
    </Modal>
  );
}
